import moment from 'moment';
import _ from 'underscore';

var CurrentUser = require("lib/account/CurrentUser");

var SelectorUtility = require("lib/shared/SelectorUtility");
var WritingSelectors = require("lib/selectors/WritingSelectors");
var RosterSelectors = require("lib/selectors/RosterSelectors");


//////////////////////////////////////////////
// Logs //////////////////////////////////////
//////////////////////////////////////////////

export function logs({ state, filters, conditions }) {
	return SelectorUtility.filterBy(state.logs, filters, conditions);
}

//////////////////////////////////////////////
// Books /////////////////////////////////////
//////////////////////////////////////////////

export function book({ state, id }) {
	return state.books[id];
}
export function isLoadingLogs({ state, key, userIDs }) {
	// TODO: standardize FE requests
	// for large requests, return true if any logs are in state
	if (userIDs && $wr.isLargeRequest(userIDs)) {
		var logsInState = _.some(_.keys(state.logs), (key) => { return state.logs[key].id !== undefined })
		if (logsInState) { return false }
	}

	key = key || "index";
	return state.logs.loading[key];
}

export function books({ state, filters, conditions }) {
	conditions = conditions || {};
	// Unpack the values stored for specifc start and end times
	var rangeKey = "activity:" + (conditions.startDate || "any") + ":" + (conditions.endDate || "any");

	var unpackedBooks = _.map(SelectorUtility.allRecords(state.books), (book) => {
		return _.extend({}, book, book[rangeKey]);
	});

	// Now, filter by date, user, etc.
	return _.filter(SelectorUtility.filterBy(unpackedBooks, filters, conditions), (book) => {
		if (!_.isEmpty(book.text_id) && book.text_id !== 'null' && book.text_id !== 'undefined') {
			// filter by readBook status
			if (conditions.readBook && (conditions.readBook == 'yes' || conditions.readBook == 'no')) {
				if (conditions.readBook == 'yes' && book.read_book_yes) {
					return book
				} else if (conditions.readBook == 'no' && book.read_book_no) {
					return book
				}
			} else {
				return book	
			}
		}
	});
}

export function isLoadingBooks({ state, key, userIDs }) {
	// TODO: standardize FE requests
	// for large requests, return true if any books are in state
	if (userIDs && $wr.isLargeRequest(userIDs)) {
		var booksInState = _.some(_.keys(state.books), (key) => { return state.books[key].id !== undefined })
		if (booksInState) { return false }
	}

	key = key || "index";
	return state.books.loading[key];
}

export function booksWithRevisables({ state, filters, conditions }) {
	var out = [];

	_.each(books({ state, filters, conditions }), (book) => {
		if (book.quiz_revisable_counts) {
			out.push({ text_id: book.text_id, type: "quiz" });
		}

		if (book.answer_revisable_counts) {
			out.push({ text_id: book.text_id, type: "answer" });
		}

		if (book.review_revisable_counts) {
			out.push({ text_id: book.text_id, type: "review" });
		}
	})
	return out;
}

export function bookIDsFromTasks({ state }) {
	return _.uniq(_.pluck(state.tasks, "subject_id"));
}

export function assignedURLBooks({ state, studentID }) {
	if (studentID) {
		var tasks = WritingSelectors.tasks({
			state, filters: { subject_type: "URLPick", user_id: studentID }
		});

	} else {
		var tasks = WritingSelectors.tasks({
			state, filters: { subject_type: "URLPick" }
		});
	}

	return books({ state, conditions: { textIDs: _.pluck(tasks, "subject_id") } })
}

export function assignedTitleBooks({ state, studentID }) {
	if (studentID) {
		var tasks = WritingSelectors.tasks({
			state, filters: { subject_type: "TitlePick", user_id: studentID }
		});

	} else {
		var tasks = WritingSelectors.tasks({
			state, filters: { subject_type: "TitlePick" }
		});
	}

	return books({ state, conditions: { textIDs: _.pluck(tasks, "subject_id") } })
}

//////////////////////////////////////////////
// Platforms /////////////////////////////////
//////////////////////////////////////////////

export function platform({ state, id }) {
	return state.platforms[id];
}

export function platforms({ state, filters, conditions }) {
	var platforms = SelectorUtility.filterBy(state.platforms, filters, conditions);
	return _.sortBy(platforms, "name");
};

//////////////////////////////////////////////
// Reading Levels ////////////////////////////
//////////////////////////////////////////////

export function readingLevels({ state, filters, conditions }) {
	return SelectorUtility.filterBy(state.readingLevels, filters, conditions);
}

export function assessmentDates({ state, filters, conditions, sinceSchoolYear, untilPresent }) {
	var rls = readingLevels({ state, filters, conditions });

	var dates = _.pluck(rls, "assessment_date");

	var slPrefs = RosterSelectors.globalStudentListPrefs({ state });
	if (slPrefs) {
		dates = dates.concat(slPrefs.cloze_test_dates) // This may not work the 2nd year
	}

	dates = _.uniq(_.compact(dates));

	if (sinceSchoolYear) {
		var startDate = moment(
			CurrentUser.fetchSchoolYearDates().startDate
		).format("YYYY-MM-DD");

		dates = dates.filter(x => x >= startDate).sort();
	}

	if (untilPresent) {
		var endDate = moment().format("YYYY-MM-DD");
		dates = dates.filter(x => x <= endDate).sort();

	}

	return dates;
}

export function isLoadingReadingLevels({ state, key, userIDs }) {
	// TODO: standardize FE requests
	// for large requests, return true if any reading levels are in state
	if (userIDs && $wr.isLargeRequest(userIDs)) {
		var readingLevelsInState = _.some(_.keys(state.readingLevels), (key) => { return state.readingLevels[key].reading_level !== undefined })
		if (readingLevelsInState) { return false }
	}

	key = key || "index";
	return state.readingLevels.loading[key];
}



// WEBPACK FOOTER //
// ./modules/lib/selectors/ReadingSelectors.js